@if (control()) {
  <mat-form-field>
    <input
      matInput
      readonly
      [placeholder]="placeholderTime()"
      [matTimepicker]="timepicker"
      [formControl]="formControl"
    />
    <mat-timepicker interval="15min" #timepicker />
    <button
      class="btn calendar-btn-m bi bi-clock btn-primary"
      aria-label="Open time picker"
    ></button>
  </mat-form-field>
}

@if (!control()) {
  <mat-form-field>
    <input
      matInput
      readonly
      [matTimepicker]="timepicker"
      [(ngModel)]="selectedDate"
      [placeholder]="placeholderTime()"
      [ngModelOptions]="{ updateOn: 'change' }"
      (ngModelChange)="onTimeChange($event)"
    />
    <mat-timepicker interval="15min" #timepicker />
    <button
      class="btn calendar-btn-m bi bi-clock btn-primary"
      aria-label="Open time picker"
    ></button>
  </mat-form-field>
}
